export const validatePhoneNumber = (phone) => {
  // Indian phone number regex: starts with 6-9 and followed by 9 digits
  const phoneRegex = /^[6-9]\d{9}$/;
  return phoneRegex.test(phone);
};
